import { atom, SetStateAction } from 'jotai';
import { RESET } from 'jotai/utils';
import { focusAtom } from 'jotai-optics';
import { cleanDefaultValuesURLSearchParams } from 'src/common/utils/urlSearchParamsUtils';
import { pick } from 'lodash';

const INITIAL_DASHBOARD_ACCOUNT_VALUE = {
  account: null,
};

type DashboardAtomValues = { account: string | null };

export const initialDashboardAtom = atom<DashboardAtomValues>(INITIAL_DASHBOARD_ACCOUNT_VALUE);

export const dashboardAtom = atom(
  (get) => get(initialDashboardAtom),
  (_get, set, newValue: SetStateAction<DashboardAtomValues> | typeof RESET) => {
    if (newValue === RESET) {
      return set(initialDashboardAtom, INITIAL_DASHBOARD_ACCOUNT_VALUE);
    }

    return set(initialDashboardAtom, newValue);
  },
);

export const dashboardAccountAtom = focusAtom(dashboardAtom, (optic) => optic.prop('account'));

export const dashboardUrlParamsAtom = atom(
  (get) => {
    const filters = get(dashboardAtom);
    const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(
      filters,
      INITIAL_DASHBOARD_ACCOUNT_VALUE,
    );
    const searchParams = new URLSearchParams({
      ...cleanedFiltersValues,
    });

    return searchParams;
  },
  (_, set, urlSearchParams: URLSearchParams) => {
    const filters = Object.fromEntries(urlSearchParams);
    const { account } = pick(filters, Object.keys(INITIAL_DASHBOARD_ACCOUNT_VALUE));
    set(dashboardAtom, { account });
  },
);
